// extracted by mini-css-extract-plugin
export default {"display":"F1591H","iframe":"wtSyAJ"};